module.exports = __webpack_public_path__ + "img/icon-shutter.b88b133c.svg";